import { alpha, Theme } from '@mui/material/styles';

interface PlaygroundStyles {
  [key: string]: any;
}

export const playgroundStyles = (theme: Theme): PlaygroundStyles => ({
  container: {
    p: 3,
    height: 'calc(100vh - 64px)',
    display: 'flex',
    flexDirection: 'column',
  },
  mainPaper: {
    p: 3,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    mb: 2,
    borderRadius: 2,
  },
  controlsContainer: {
    mb: 2,
  },
  clearButton: {
    height: '56px',
    borderRadius: 2,
    textTransform: 'none' as const,
    '&:hover': {
      bgcolor: alpha(theme.palette.error.main, 0.04),
    },
  },
  divider: {
    mb: 2,
    borderColor: theme.palette.divider,
  },
  emptyStateBox: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    mb: 2,
    p: 2,
    bgcolor: theme.palette.mode === 'dark'
      ? alpha(theme.palette.common.white, 0.03)
      : alpha(theme.palette.common.black, 0.02),
    borderRadius: 1,
    textAlign: 'center' as const,
  },
  chatContainer: {
    flex: 1,
    mb: 2,
    position: 'relative' as const,
  },
  modelPaper: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 1,
    overflow: 'hidden',
    bgcolor: theme.palette.background.paper,
  },
  modelHeader: {
    p: 1,
    bgcolor: theme.palette.mode === 'dark'
      ? alpha(theme.palette.common.white, 0.05)
      : theme.palette.primary.light,
    color: theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.common.white,
    fontWeight: 'medium',
    textAlign: 'center' as const,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '0.875rem',
  },
  modelChatBox: {
    flex: 1,
    overflowY: 'auto',
    p: 2,
    bgcolor: theme.palette.mode === 'dark'
      ? alpha(theme.palette.common.white, 0.03)
      : alpha(theme.palette.common.black, 0.02),
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: alpha(theme.palette.common.black, 0.2),
      borderRadius: '3px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: alpha(theme.palette.common.black, 0.3),
    },
  },
  emptyChatBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    color: theme.palette.text.secondary,
  },
  inputContainer: {
    display: 'flex',
    gap: 1,
    mt: 2,
    alignItems: 'flex-start',
  },
  sendButton: {
    minWidth: '120px',
    height: '56px',
    borderRadius: 2,
    textTransform: 'none' as const,
  },

  // 消息气泡样式
  messageBubble: {
    p: 2,
    borderRadius: '18px',
    maxWidth: '70%',
    boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
    wordBreak: 'break-word' as const,
  },
  userMessage: {
    borderRadius: '18px 18px 6px 18px',
    bgcolor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
  assistantMessage: {
    borderRadius: '18px 18px 18px 6px',
    bgcolor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
  },
  errorMessage: {
    borderRadius: '18px 18px 18px 6px',
    bgcolor: theme.palette.error.light,
    color: theme.palette.error.contrastText,
    border: `1px solid ${theme.palette.error.main}`,
  },

  // 加载状态样式
  loadingIndicator: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    py: 1,
    px: 2,
    color: theme.palette.text.secondary,
  },

  // 连接状态样式
  connectionStatus: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    mb: 1,
  },

  // 模型选择器样式
  modelSelector: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 2,
    },
  },

  // 工具提示样式
  tooltip: {
    bgcolor: theme.palette.common.black,
    color: theme.palette.common.white,
    fontSize: '0.875rem',
    borderRadius: 1,
  },

  // 按钮样式
  actionButton: {
    borderRadius: 2,
    textTransform: 'none' as const,
    minWidth: 'auto',
  },

  // 响应式设计
  responsiveControls: {
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column' as const,
      '& .MuiGrid-item': {
        width: '100%',
      },
    },
  },

  // 深色模式适配
  darkModeAdaptation: {
    [theme.palette.mode === 'dark' ? '&' : '']: {
      borderColor: alpha(theme.palette.common.white, 0.1),
    },
  },
});